import { BiStopwatch } from 'react-icons/bi';
import { HStack, Text } from 'ui_2';

type Props = {
  counter: number;
};

export const Counter = ({ counter }: Props) => {
  return (
    <HStack
      className={`h-[41px] w-[100px] flex-none items-center justify-center gap-2 rounded-lg ${
        counter <= 10 ? 'bg-mcRed' : 'bg-mcGreen-100'
      } text-base sm:text-lg lg:text-xl`}
    >
      <BiStopwatch />
      <Text family='space' font='md' className='lg:text-xl'>
        {counter}
      </Text>
    </HStack>
  );
};
